import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "property-marks" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_chip = _resolveComponent("v-chip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.marks, (mark) => {
      return (_openBlock(), _createBlock(_component_v_chip, {
        key: mark.label,
        size: "x-small",
        label: "",
        color: mark.color,
        variant: mark.condition ? 'outlined' : 'tonal',
        title: mark.condition || undefined
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, {
            start: "",
            size: "x-small"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(mark.icon), 1)
            ]),
            _: 2
          }, 1024),
          _createTextVNode(_toDisplayString(mark.label), 1)
        ]),
        _: 2
      }, 1032, ["color", "variant", "title"]))
    }), 128))
  ]))
}